import classNames from 'classnames';
import { FC } from 'react';

import './FormField.scss';

interface Props {
  labelName?: string;
  errors?: string[];
  id?: string;
  column?: boolean;
  noFlex?: boolean;
  checkRight?: boolean;
}

const FormField: FC<Props> = ({ children, labelName, errors, id, column, noFlex, checkRight }) => {
  const fieldId = id || `field-${(labelName || '').replace(/\s+/g, '')}`;
  return (
    <div
      className={classNames('form-group', 'FormField', {
        'check-right': checkRight,
      })}
    >
      <div className="FormField-content-wrapper">
        {labelName && <label htmlFor={fieldId}>{labelName}</label>}
        <div
          className={classNames({ 'FormField-content': !noFlex, 'FormField-column': column })}
          id={fieldId}
        >
          {children}
        </div>
      </div>
      {errors && errors.length > 0 && (
        <div className="FormField-errors">
          {errors.map((e, i) => (
            <div key={`error-${i}`} className="FormField-error">
              {e}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FormField;
